export class UserDetails {
    Username: string;
    Password: string;
}